import { h } from 'preact';
import { useControls } from '../../common/creative/hooks/useControls';
import { useManualDuration } from '../../common/creative/hooks/useManualDuration';
import { useSetAdBackgroundColor } from '../../common/creative/hooks/useSetAdBackgroundColor';
import { useSetAdIsDisplay } from '../../common/creative/hooks/useSetAdIsDisplay';
import { useVPAIDPlayState } from '../../common/creative/hooks/useVPAIDPlayState';
import { BrandPulseCreative } from './creative';

export function BrandPulse() {
  useSetAdBackgroundColor('#fff');
  useSetAdIsDisplay(true);

  const { updateTime } = useControls();
  const { playState } = useVPAIDPlayState();
  useManualDuration(playState.isPlaying, 15, updateTime);

  return <BrandPulseCreative />;
}
